import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AiTextPayload, AiTextResponse } from '../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AiService {
  constructor(private http: HttpClient) {}

  generateText(payload: AiTextPayload): Observable<AiTextResponse> {
    return this.http.post<AiTextResponse>(`/ai/text/generate`, payload);
  }

  lengthenText(payload: AiTextPayload): Observable<AiTextResponse> {
    return this.http.post<AiTextResponse>(`/ai/text/lengthen`, payload);
  }

  shortenText(payload: AiTextPayload): Observable<AiTextResponse> {
    return this.http.post<AiTextResponse>(`/ai/text/shorten`, payload);
  }

  conciseText(payload: AiTextPayload): Observable<AiTextResponse> {
    return this.http.post<AiTextResponse>(`/ai/text/concise`, payload);
  }
}
